module.exports = __webpack_public_path__ + "static/media/hc-mobile.79ef704f.png";